import {ActionTree} from 'vuex';
import {CustomerDetailsInterface, CustomerStateInterface} from '@/store/modules/customer/types';
import {RootState} from '@/store/types';
import {AxiosResponse} from 'axios';
import ApiException from '@/exceptions/ApiException';
import {api} from '@/services/http';

export const actions: ActionTree<CustomerStateInterface, RootState> = {

    /**
     * Fetch customer details for the authenticated user.
     *
     * @param {any} commit
     */
    async fetchCustomerDetails({commit}: { commit: any }): Promise<void> {
        const response: AxiosResponse = await api.axios.get(`api/customer/details`);

        if (!response.data) {
            throw new ApiException(401, 'Unable to find user');
        }

        const details: any = response.data;

        const payload: CustomerDetailsInterface = {
            votesLeft: details.votes_left,
        };

        commit('customerDetailsLoaded', payload);
    },

    /**
     * Remove customer details from the store.
     *
     * @param commit
     */
    removeCustomerDetails({commit}: { commit: any }): void {
        commit('customerDetailsRemoved');
    },
};
